export class CommandUniformMap {
    constructor(stateName) {
    }
    addShaderUniform(propertyID, propertyKey, uniformtype, options) {
        throw "need override it";
    }
    addShaderUniformArray(propertyID, propertyName, uniformtype, arrayLength) {
        throw "need override it";
    }
    setDefaultTextureData(key, defaultTex) {
        throw "need override it";
    }
}
